import { render, staticRenderFns } from "./reiniciar-datos-proceso-electoral.vue?vue&type=template&id=c98eb618&"
import script from "./reiniciar-datos-proceso-electoral.vue?vue&type=script&lang=js&"
export * from "./reiniciar-datos-proceso-electoral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports